import { GiftRequestStatus } from '@/api/gifts-requests';

interface StatusBadgeProps {
  status: GiftRequestStatus;
}

const statusMap = {
  [GiftRequestStatus.NEW]: {
    label: 'Mới',
    className: 'bg-blue-100 text-blue-800',
  },
  [GiftRequestStatus.PENDING]: {
    label: 'Chờ duyệt',
    className: 'bg-yellow-100 text-yellow-800',
  },
  [GiftRequestStatus.BUSINESS_APPROVED]: {
    label: 'Quản lý đã duyệt',
    className: 'bg-blue-100 text-blue-800',
  },
  [GiftRequestStatus.ADMIN_APPROVED]: {
    label: 'Admin đã duyệt',
    className: 'bg-purple-100 text-purple-800',
  },
  [GiftRequestStatus.GENERAL_DIRECTOR_APPROVED]: {
    label: 'Giám đốc đã duyệt',
    className: 'bg-indigo-100 text-indigo-800',
  },
  [GiftRequestStatus.BUSINESS_REJECTED]: {
    label: 'Quản lý đã từ chối',
    className: 'bg-red-100 text-red-800',
  },
  [GiftRequestStatus.ADMIN_REJECTED]: {
    label: 'Admin đã từ chối',
    className: 'bg-red-100 text-red-800',
  },
  [GiftRequestStatus.GENERAL_DIRECTOR_REJECTED]: {
    label: 'Giám đốc đã từ chối',
    className: 'bg-red-100 text-red-800',
  },
  [GiftRequestStatus.COMPLETED]: {
    label: 'Đã hoàn thành',
    className: 'bg-green-100 text-green-800',
  },
  [GiftRequestStatus.APPROVED]: {
    label: 'Đã duyệt',
    className: 'bg-green-100 text-green-800',
  },
  [GiftRequestStatus.REJECTED]: {
    label: 'Đã từ chối',
    className: 'bg-red-100 text-red-800',
  },
};

const StatusBadge = ({ status }: StatusBadgeProps) => {
  return (
    <div
      className={`px-2 py-1 rounded-full text-sm font-medium inline-block text-center min-w-30 ${statusMap[status].className}`}
    >
      {statusMap[status].label}
    </div>
  );
};

export default StatusBadge;
